import Vue from 'vue'
import store from '../index.js'
import axios from 'axios'


export default {
  get (url, request) {
    request.credentials = true
    request.session = {user: JSON.parse(Vue.cookie.get('authUser'))}
    return Vue.http.get(url, request)
      .then((response) => Promise.resolve(response.body))
      .catch((error) => Promise.reject(error))
  },
  post (url, request) {
    return Vue.http.post(url, request, {emulateJSON: true, credentials: true, session: {user: JSON.parse(Vue.cookie.get('authUser')) } })
      .then((response) => Promise.resolve(response))
      .catch((error) => Promise.reject(error))
  },
  patch (url, request) {
    request.credentials = true
    request.session = {user: JSON.parse(Vue.cookie.get('authUser'))}
    return Vue.http.patch(url, request)
      .then((response) => Promise.resolve(response))
      .catch((error) => Promise.reject(error))
  },
  delete (url, request) {
    request.credentials = true
    request.session = {user: JSON.parse(Vue.cookie.get('authUser'))}
    return Vue.http.delete(url, request)
      .then((response) => Promise.resolve(response))
      .catch((error) => Promise.reject(error))
  },
  put (url, request) {
    request.credentials = true
    request.session = {user: JSON.parse(Vue.cookie.get('authUser'))}
    return Vue.http.put(url, request, {emulateJSON: true, credentials: true, session: {user: JSON.parse(Vue.cookie.get('authUser')) } })
      .then((response) => Promise.resolve(response))
      .catch((error) => Promise.reject(error))
  },
  setAuthToken (token) {
    Vue.http.headers.common['x-access-token'] = token
    Vue.http.interceptors.push((req, next) => {
      req.headers.set('x-access-token', token)
      req.session = {}
      next((res) => {
        if (res.status === 401) {
          console.log("401");
          store.dispatch('auth/logOut')
          window.location = "/";
          // return new Promise(resolve => {
          //   refreshToken(_ => {
          //     resolve(Vue.http(req))
          //   })
          // })
        }
      })
    })
  },
  secure (options) {
    return axios(options)
      .then(function (response) {
        return response
      })
      .catch(function (error) {
        return error
      });
  }
}



// WEBPACK FOOTER //
// ./src/store/utils/api.js